import * as tslib_1 from "tslib";
import { GeocodeService } from '../services/geocode.service';
import { Api } from './api';
import * as i0 from "@angular/core";
import * as i1 from "./api";
import * as i2 from "../services/geocode.service";
var SearchApi = /** @class */ (function () {
    function SearchApi(api, geocodeService) {
        this.api = api;
        this.geocodeService = geocodeService;
    }
    SearchApi.prototype.getSearchResultTypes = function (excludeTypes) {
        if (excludeTypes === void 0) { excludeTypes = null; }
        return [
            { name: 'feature', pluralDisplayName: 'Features' },
            { name: 'layer', pluralDisplayName: 'Layers' },
            { name: 'map', pluralDisplayName: 'Maps' }
        ].filter(function (type) { return (!excludeTypes || !excludeTypes.includes(type.name)); });
    };
    SearchApi.prototype.getAoiAssetIdOptions = function (columnName, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n            query GetAoiAssetIdOptions($columnName: [String]) {\n                aoiAssetIdOptions(columnName: $columnName) {\n                    " + options + "\n                }\n            }\n        ", { columnName: columnName }, 'GET', '')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SearchApi.prototype.getAssetIds = function (query, stringIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n                query GetAssets($stringIds: String) {\n                    " + query + "\n                }\n            ", { stringIds: stringIds }, 'GET', '')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SearchApi.prototype.getAddressResults = function (text, maxSuggestions) {
        if (maxSuggestions === void 0) { maxSuggestions = 5; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var suggestResult, searchResults;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.geocodeService.suggest(text, maxSuggestions).toPromise()];
                    case 1:
                        suggestResult = _a.sent();
                        searchResults = suggestResult.suggestions.map(function (x) {
                            return {
                                name: x.text,
                                primaryText: x.text,
                                magicKey: x.magicKey,
                                type: 'address',
                                layerTitle: 'Address'
                            };
                        });
                        return [2 /*return*/, searchResults];
                }
            });
        });
    };
    SearchApi.prototype.getMapcoreResults = function (text, userId, type, first, excludeTypes, applicationId) {
        if (userId === void 0) { userId = 0; }
        if (type === void 0) { type = ''; }
        if (first === void 0) { first = 10; }
        if (excludeTypes === void 0) { excludeTypes = null; }
        if (applicationId === void 0) { applicationId = 0; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, nameSearch, queryText, dataResult, results, resultTypes, resultTypes_1, resultTypes_1_1, resultType, pluralType, typeResults;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!userId) {
                            userId = 0;
                        }
                        nameSearch = "%" + text + "%";
                        queryText = this.getQueryTextBasedOnType(type, userId > 0, excludeTypes);
                        return [4 /*yield*/, this.api.http2.graphqlRequest(queryText, { queryText: queryText, text: text, nameSearch: nameSearch, first: first, userId: userId, applicationId: applicationId }, 'GET')];
                    case 1:
                        dataResult = _b.sent();
                        if (dataResult.maps && dataResult.users && dataResult.users.length > 0) {
                            dataResult.maps = dataResult.users[0].maps.concat(dataResult.maps);
                        }
                        results = {};
                        resultTypes = this.getSearchResultTypes(excludeTypes);
                        try {
                            for (resultTypes_1 = tslib_1.__values(resultTypes), resultTypes_1_1 = resultTypes_1.next(); !resultTypes_1_1.done; resultTypes_1_1 = resultTypes_1.next()) {
                                resultType = resultTypes_1_1.value;
                                pluralType = resultType.pluralDisplayName.toLowerCase();
                                typeResults = dataResult[pluralType];
                                this.standardizeDisplayFields(typeResults, resultType.name);
                                results[resultType.name] = typeResults;
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (resultTypes_1_1 && !resultTypes_1_1.done && (_a = resultTypes_1.return)) _a.call(resultTypes_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [2 /*return*/, results];
                }
            });
        });
    };
    SearchApi.prototype.getResults = function (text, userId, type, first, excludeTypes, applicationId) {
        if (userId === void 0) { userId = 0; }
        if (type === void 0) { type = ''; }
        if (first === void 0) { first = 10; }
        if (excludeTypes === void 0) { excludeTypes = null; }
        if (applicationId === void 0) { applicationId = 0; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var results, addressResults, featureKey;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMapcoreResults(text, userId, type, first, excludeTypes, applicationId)];
                    case 1:
                        results = _a.sent();
                        if (!(type === '' || type === 'address')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getAddressResults(text)];
                    case 2:
                        addressResults = _a.sent();
                        featureKey = 'feature';
                        if (addressResults && addressResults.length) {
                            results[featureKey] = results[featureKey].concat(addressResults);
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/, results];
                }
            });
        });
    };
    SearchApi.prototype.standardizeDisplayFields = function (items, type) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_2, _a, items_1, items_1_1, item, id, displayType;
            return tslib_1.__generator(this, function (_b) {
                try {
                    for (items_1 = tslib_1.__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                        item = items_1_1.value;
                        item.type = type;
                        if (type !== 'feature') {
                            item.primaryText = item.name;
                            id = item.id;
                            displayType = type.toUpperCase();
                            item.secondaryText = displayType + ": " + id;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                return [2 /*return*/];
            });
        });
    };
    SearchApi.prototype.getQueryTextBasedOnType = function (type, includeUserMaps, excludeTypes) {
        if (includeUserMaps === void 0) { includeUserMaps = false; }
        if (excludeTypes === void 0) { excludeTypes = null; }
        var queries = [];
        var params = [];
        var includeTextSearch;
        var includeNameSearch;
        if ((!type || type === 'feature') && (!excludeTypes || !excludeTypes.includes('feature'))) {
            queries.push("\n            features(search: $text, applicationId: $applicationId, first: $first, orderBy:[\"searchPriority\"]){\n                primaryText,secondaryText,tertiaryText,layerTitle,layerId,objectId\n            }");
            includeTextSearch = true;
        }
        if ((!type || type === 'layer') && (!excludeTypes || !excludeTypes.includes('layer'))) {
            queries.push("\n            layers(search: $nameSearch, isSystem: true, first: $first, applicationId: $applicationId, orderBy:[\"searchPriority\"]){\n                id, name, description\n            }");
            includeNameSearch = true;
        }
        if ((!type || type === 'map') && (!excludeTypes || !excludeTypes.includes('map'))) {
            queries.push("\n            maps(search: $nameSearch, isSystem: true, first: $first){\n            id, name, description\n            }");
            if (includeUserMaps) {
                queries.push("\n                users(id: $userId) {maps(search: $nameSearch, first: $first){\n                id, name\n                }}");
                params.push('$userId: [Int]');
            }
            includeNameSearch = true;
        }
        params.push('$first: [Int]');
        if (includeTextSearch) {
            params.push('$text: [String]');
        }
        if (includeNameSearch) {
            params.push('$nameSearch: [String]');
        }
        params.push('$applicationId: Int');
        var paramText = params.join(',');
        var queryText = queries.join(',');
        var fullQuery = "query Search(" + paramText + ") {\n            " + queryText + "\n        }";
        return fullQuery;
    };
    SearchApi.ngInjectableDef = i0.defineInjectable({ factory: function SearchApi_Factory() { return new SearchApi(i0.inject(i1.Api), i0.inject(i2.GeocodeService)); }, token: SearchApi, providedIn: "root" });
    return SearchApi;
}());
export { SearchApi };
